import { useRouter } from '@bprogress/next';
import { getProductSlug } from '@util/urlHelpers';
import { useCreateListing } from 'app/create-listing/_context';
import { useAuth } from 'context/AuthContext';
import { isVehicleCategory, ProductDocument } from 'models/product';

const ListingActionButtons = ({
  variant,
  product,
  saveDraft,
  onSubmitClick,
  isLoading,
  isDraft = false,
}: {
  variant?: 'edit-listing' | 'create-listing';
  product?: ProductDocument | null;
  saveDraft: () => void;
  onSubmitClick: () => void;
  isLoading?: boolean;
  isDraft?: boolean;
}) => {
  const router = useRouter();
  const { setCurrentStep, currentStep, goToStep } = useCreateListing();
  const { userDoc } = useAuth();
  const isIntegrationLocked =
    product?.integration_info?.type === 'shopify' ||
    product?.integration_info?.type === 'ebay';
  const submitDisabled =
    !!isLoading || (isIntegrationLocked && !userDoc?.roles?.admin);
  return (
    <div className="flex w-full flex-col items-center justify-normal gap-8 whitespace-nowrap">
      {variant === 'edit-listing' ? (
        <>
          <button
            onClick={onSubmitClick}
            disabled={submitDisabled}
            className="flex h-[5.5rem] w-full items-center justify-center gap-x-2 rounded-full bg-brand-secondary px-8 text-[2.1rem] font-semibold text-white transition-colors duration-75 ease-linear hover:bg-brand-secondary-darker disabled:cursor-not-allowed disabled:opacity-50 sm:w-[48rem]"
            type="button"
          >
            {isLoading
              ? 'Processing...'
              : product?.is_draft
              ? 'Publish Item'
              : 'Save Changes'}
          </button>
          {product?.is_draft && (
            <button
              onClick={saveDraft}
              className="flex h-[5.5rem] w-full grow items-center justify-center gap-x-2 rounded-full bg-brand-lightest-gray px-8 text-[2.1rem] font-semibold text-black sm:w-[48rem] sm:grow-0"
              type="button"
              disabled={isLoading}
            >
              {isLoading ? 'Updating...' : 'Update Draft'}
            </button>
          )}
        </>
      ) : (
        <>
          <button
            type="button"
            onClick={onSubmitClick}
            className="flex h-[5.5rem] w-full grow items-center justify-center gap-x-2 rounded-full bg-brand-secondary px-8 text-[2.1rem] font-semibold text-white transition-colors duration-75 hover:bg-brand-secondary-darker sm:w-[48rem] sm:grow-0"
            disabled={isLoading}
          >
            {isLoading ? 'Publishing...' : 'Publish Listing'}
          </button>
          <button
            onClick={saveDraft}
            className="flex h-[5.5rem] w-full grow items-center justify-center gap-x-2 rounded-full border-[1px] border-zinc-600 bg-white px-8 text-[2.1rem] font-semibold text-black sm:w-[48rem] sm:grow-0"
            type="button"
            disabled={isLoading}
          >
            {isLoading
              ? 'Saving...'
              : isDraft
              ? 'Update Draft'
              : 'Save As Draft'}
          </button>
        </>
      )}
      <button
        onClick={() => {
          if (variant === 'edit-listing' && product) {
            router.push(getProductSlug(product));
          } else {
            if (isVehicleCategory(product?.category)) {
              goToStep('find-vehicle');
              return;
            }
            if (
              product?.sources?.find(
                (source) => source.collection === 'data_depot'
              )
            ) {
              setCurrentStep(0);
              return;
            }
            if (currentStep > 0) {
              setCurrentStep(currentStep - 1);
            } else {
              router.back();
            }
          }
        }}
        className="flex h-[5.5rem] w-full items-center justify-center gap-x-2 rounded-full border-[1px] border-zinc-600 bg-white px-8 text-[2.1rem] font-semibold text-black sm:w-[48rem]"
        type="button"
        disabled={isLoading}
      >
        Back
      </button>
    </div>
  );
};

export default ListingActionButtons;
